import styled from 'styled-components'

export const Carousel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  height: 100%;
  min-height: 0;
  gap: 0.85rem;
`

export const Viewport = styled.div`
  position: relative;
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;
  overflow: hidden;
`

export const Track = styled.div`
  display: flex;
  align-items: stretch;
  height: 100%;
  width: 100%;
  transform: translateX(${({ $index }) => `-${$index * 100}%`});
  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);
`

export const Slide = styled.div`
  display: flex;
  flex: 0 0 100%;
  align-items: stretch;
  width: 100%;
  min-width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 2px;
`

export const IndicatorsCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.1rem;
  width: 100%;
  height: 100%;
  min-height: 0;
  margin-inline: auto;
  padding: 1.5rem 1.6rem;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) => theme.colors.background};
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.1);
  overflow: auto;
`

export const IndicatorsTitle = styled.h3`
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.textPrimary};
`

export const IndicatorsSubtitle = styled.p`
  margin: 0.35rem 0 0;
  font-size: 0.875rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const IndicatorGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`

export const IndicatorTile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 1.15rem 1.2rem;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  background: ${({ theme }) =>
    theme.name === 'dark' ? theme.colors.backgroundSecondary : '#f8fafc'};
`

export const IndicatorLabel = styled.span`
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.action.primary.bgActive};
`

export const IndicatorValue = styled.span`
  font-size: clamp(1.35rem, 2.2vw, 1.75rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.textPrimary};
`

export const IndicatorMeta = styled.span`
  font-size: 0.8125rem;
  line-height: 1.35;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const Dots = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  z-index: 3;
  padding: 2px 0 4px;
`

export const Dot = styled.button`
  width: ${({ $active }) => ($active ? '22px' : '10px')};
  height: 10px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: ${({ $active, theme }) =>
    $active
      ? theme.colors.action.primary.bg
      : theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.45)'
        : 'rgba(15, 23, 42, 0.35)'};
  box-shadow: ${({ $active }) =>
    $active ? '0 0 0 3px rgba(62, 207, 142, 0.25)' : 'none'};
  cursor: pointer;
  transition: width 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.action.primary.bgHover};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.action.primary.bg};
    outline-offset: 2px;
  }
`
